import React from 'react';
import Settings from '../../components/settings';
import Layout from '../layout';

const SettingsContainer = () => (
  <Layout>
    <Settings />
  </Layout>
);

export default SettingsContainer;
